const siteFooter = {
  displayField: 'address',
  name: 'Site Footer',
  description: 'Shop site and main site Footer schema.',
  fields: [
    {
      id: 'city',
      name: 'City',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'bodyRichText',
      name: 'Rich Text',
      type: 'RichText',
      localized: false,
      required: true,
      validations: [
        { enabledMarks: [], message: 'Marks are not allowed' },
        {
          enabledNodeTypes: [ 'embedded-asset-block' ],
          message: 'Only asset nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'address',
      name: 'Address',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'svgs',
      name: 'Social Icons',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    },
    {
      id: 'columnOne',
      name: 'Column One',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    },
    {
      id: 'columnTwo',
      name: 'Column Two',
      type: 'Array',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    },
    {
      id: 'columnThree',
      name: 'ColumnThree',
      type: 'Array',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    },
    {
      id: 'columnFour',
      name: 'Column Four',
      type: 'Array',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    },
    {
      id: 'columnFive',
      name: 'Column Five',
      type: 'Array',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    },
    {
      id: 'columnSix',
      name: 'Column Six',
      type: 'Array',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    }
  ],
  metadata: {
    annotations: {
      ContentTypeField: {
        columnOne: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ]
      }
    }
  },
  sys: {
    id: 'siteFooter',
    version: 50,
    updatedAt: '2023-08-02T18:55:50.058Z'
  }
};
export default siteFooter;